import { render, staticRenderFns } from "./BaseHero.vue?vue&type=template&id=25593506&scoped=true&"
var script = {}
import style0 from "./BaseHero.vue?vue&type=style&index=0&id=25593506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25593506",
  null
  
)

export default component.exports